angular.module('indexModule')
    .controller('SearchController',
        ['$scope', '$log', 'indextree', 'searchFactory', 'searchService', 'progressCircle', 'ntaAlert',
function ($scope,   $log,   indextree,   searchFactory,   searchService,   progressCircle,   ntaAlert) {
    'use strict';
    const vm = this;
    vm.indextree = indextree;
    vm.searchQuery = searchFactory.searchQuery;

    vm.searchResults = searchFactory.searchResults;

    vm.search = async function () {
        const searchQuery = vm.searchQuery;
        searchFactory.searchQuery = searchQuery;
        if (!searchQuery)
            return;

        progressCircle.setShowProgressValue(true, "aan het zoeken", false);
        try {
            const results = await searchService.searchItemsContaining(searchQuery);

            results.searchResultCount = results.projectResults.projects.length + results.buildingResults.buildings.length + results.folderResults.folders.length;
            loadPaths(results.buildingResults, results.buildingResults.buildings);
            loadPaths(results.projectResults, results.projectResults.projects);
            loadPaths(results.folderResults, results.folderResults.folders);

            vm.searchResults = results;
            searchFactory.searchResults = results;
        } catch (err) {
            $log.error('Oeps: fout tijdens zoeken naar', searchQuery, ':', err);
            await ntaAlert.showError();
        } finally {
            progressCircle.setShowProgressValue(false);
        }
    };

    function loadPaths(category, searchResults) {
        category.paths = searchResults.map(result => getFolderPath(result.FolderId));
    }

    function getFolderPath(folderId) {
        let folder = indextree.foldersById.get(folderId);
        let path = `${folder.Name}`;
        while (folder.ParentId != -1) {
            const parentFolder = indextree.foldersById.get(folder.ParentId);
            if (parentFolder) {
                path = `${parentFolder.Name}/${path}`;
                folder = parentFolder;
            } else {
                break;
            }
        }
        return `/${path}`;
    };
}]);